(function(){
  function stage(root){
    var s=root.querySelectorAll('.lf-slide'),d=root.querySelectorAll('.lf-dots button'),i=0,t;
    if(!s.length)return;
    function go(n){s[i].classList.remove('is-on');d[i]&&d[i].classList.remove('is-on');i=(n+s.length)%s.length;s[i].classList.add('is-on');d[i]&&d[i].classList.add('is-on');}
    function play(){clearInterval(t);t=setInterval(function(){go(i+1)},3500);}
    d.forEach(function(b,k){b.addEventListener('click',function(){go(k);play();});});
    root.addEventListener('mouseenter',function(){clearInterval(t)});
    root.addEventListener('mouseleave',play);
    play();
  }
  function counters(){
    var els=document.querySelectorAll('[data-lf-count]');
    if(!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;io.unobserve(e.target);
      var el=e.target,end=parseInt(el.getAttribute('data-lf-count'),10),suf=el.getAttribute('data-suf')||'',st=null;
      function f(ts){if(!st)st=ts;var p=Math.min((ts-st)/1400,1);el.textContent=Math.floor(end*(1-Math.pow(1-p,3))).toLocaleString('es-ES')+suf;if(p<1)requestAnimationFrame(f);}
      requestAnimationFrame(f);});},{threshold:.4});
    els.forEach(function(e){io.observe(e)});
  }
  function reveal(){
    if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var secs=document.querySelectorAll('main .shopify-section');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('lf-in');io.unobserve(e.target);}})},{threshold:.08});
    secs.forEach(function(s,k){if(k<2)return;var r=s.getBoundingClientRect();if(r.top<window.innerHeight)return;s.classList.add('lf-reveal');io.observe(s);});
  }
  function tilt(){
    if(window.matchMedia('(hover: none)').matches)return;
    document.querySelectorAll('.lf-card').forEach(function(c){
      c.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;c.style.transform='perspective(700px) rotateY('+(x*10)+'deg) rotateX('+(-y*10)+'deg) translateY(-4px)';});
      c.addEventListener('mouseleave',function(){c.style.transform='';});
    });
  }
  function init(){document.querySelectorAll('.lf-stage').forEach(stage);counters();reveal();tilt();}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
